import I18n from "i18n-js";
import { BillingType } from "features/user/types";

interface PlanBadgeProps {
  plan: BillingType;
  size?: "small" | "normal";
}

const getPlanColor = (plan: BillingType): string => {
  switch (plan) {
    case BillingType.TRIAL:
      return "#9E9E9E"; // Gray for Trial
    case BillingType.FREE:
      return "#4C9DF1"; // Blue for Free
    case BillingType.EDUCATION:
      return "#3E5878"; // Navy for Education
    case BillingType.STANDARD:
      return "#66BB6A"; // Green for Standard
    case BillingType.PREMIUM:
      return "#FF5722"; // Deep Orange for Premium
    default:
      return "#9E9E9E"; // Gray for unknown
  }
};

const getPlanI18nKey = (plan: BillingType): string => {
  switch (plan) {
    case BillingType.TRIAL:
      return "MSG_PLAN_TRIAL";
    case BillingType.FREE:
      return "MSG_PLAN_FREE";
    case BillingType.STANDARD:
      return "MSG_PLAN_STANDARD";
    case BillingType.PREMIUM:
      return "MSG_PLAN_PREMIUM";
    case BillingType.EDUCATION:
      return "MSG_PLAN_EDUCATION";
    default:
      return "MSG_PLAN_UNKNOWN";
  }
};

export const PlanBadge = ({
  plan,
  size = "normal",
}: PlanBadgeProps) => {
  const backgroundColor = getPlanColor(plan);
  const i18nKey = getPlanI18nKey(plan);

  return (
    <div
      className="flex-row-el flex-center rounded-full p-2"
      style={{ backgroundColor }}
    >
      <div className="flex-row-el flex-center">
        <div className="flex-col-center w-[24px] h-[24px] rounded-full mr-1 bg-white">
          <span
            className="material-symbols-outlined !text-base"
            style={{ color: backgroundColor }}
          >
            workspace_premium
          </span>
        </div>
        <p className="text-body text-xl text-white">{I18n.t(i18nKey)}</p>
      </div>
    </div>
  );
};
